(function(){
  /**
   * Simple service for working with the format of the "standards" state parameter
   *
   * This parameter is in the format [0-9]+g,[0-9]+d,[0-9]+s
   */
  angular.module('edxComponents')
    .factory('edxStandardsStateParamParser', [StandardsStateParamParserFactory]);

  function StandardsStateParamParserFactory() {

    function formatCluster(level, domain, cluster) {
      var standardsParam = '';
      if (level) {
        standardsParam = level + 'g';
        if (domain) {
          standardsParam = standardsParam + ',' + domain + 'd';

          if (cluster) {
            standardsParam = standardsParam + ',' + cluster + 's';
          }
        }
      }
      return standardsParam;
    }

    function extractLevel(standardsParam) {
      if (standardsParam) {
        var parts = /^(\d+)g.*/.exec(standardsParam);
        if (parts.length >= 2) {
          return parts[1];
        }
      }
      return undefined;
    }

    return {
      formatCluster: formatCluster,
      extractLevel: extractLevel
    };
  }
})();